var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.slides.length)?_c('section',{staticClass:"news right-container"},[_c('h2',{staticClass:"is-large"},[_vm._v("News")]),_c('Slider',{attrs:{"slides":_vm.slides}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }